import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const NabidkyList = lazy(() =>
  import('@/modules/vozidla/NabidkyList').then((m) => ({ default: m.NabidkyList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/nabidky',
  component: () => (
    <Suspense fallback={null}>
      <NabidkyList />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
